import type { FC, HTMLProps } from 'react'
import { extractProps } from './extractProps'
import { InputLayout, type InputLayoutControlProps, type StripInputProps } from './InputLayout'
import { inputCssClass } from './inputCss'
export type TextInputProps = StripInputProps<HTMLProps<HTMLInputElement>> &
  InputLayoutControlProps & { type?: 'text'; ref?: React.Ref<HTMLInputElement> }

export const TextInput: FC<StripInputProps<HTMLProps<HTMLInputElement>> & InputLayoutControlProps> = (props) => {
  const [layoutProps, inputProps] = extractProps(props)

  return (
    <InputLayout {...layoutProps}>
      <input type="text" className={inputCssClass} {...inputProps} />
    </InputLayout>
  )
}
